import React, { useEffect } from 'react'
import Store from '../../store/Store'

const POLL_INTERVAL = 60 * 1000 // 60 s

// warning banner for logged in users while flight starts are blocked (emergency kill switch)
export function SystemStatusBanner() {
	const isLoggedIn = Store.use('isLoggedIn')
	const twoFactorRequired = Store.use('twoFactorRequired')
	const twoFactorVerified = Store.use('twoFactorVerified')
	const flightStartsBlocked = Store.use('flightStartsBlocked')
	const flightStartsBlockedReason = Store.use('flightStartsBlockedReason')

	const active = !!isLoggedIn && (!twoFactorRequired || !!twoFactorVerified)

	useEffect(() => {
		if (!active) return

		Store.loadSystemStatus() // errors are not shown
		const timer = setInterval(() => Store.loadSystemStatus(), POLL_INTERVAL)

		return () => clearInterval(timer)
	}, [active])

	if (!active || !flightStartsBlocked) return null

	return (
		<div
			role="alert"
			data-pw="banner-flight-starts-blocked"
			className="w-full bg-red-600 text-white px-6 py-3 text-center font-semibold"
		>
			Achtung: Flugstarts sind derzeit gesperrt.
			{flightStartsBlockedReason ? ` Grund: ${flightStartsBlockedReason}` : ''}
		</div>
	)
}
